import { render, staticRenderFns } from "./ModalResource.vue?vue&type=template&id=92870e7e&"
import script from "./ModalResource.vue?vue&type=script&lang=js&"
export * from "./ModalResource.vue?vue&type=script&lang=js&"
import style0 from "./ModalResource.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports